<template>
    <div class="layout-topbar">
        <button class="p-link layout-menu-button" @click="onMenuToggle">
            <span class="pi pi-bars"></span>
        </button>

        <div class="layout-topbar-icons">
<!--            <span class="layout-topbar-search">-->
<!--                <InputText type="text" placeholder="Search"/>-->
<!--                <span class="layout-topbar-search-icon pi pi-search"></span>-->
<!--            </span>-->
<!--            <button class="p-link tooltip" disabled="true">-->
<!--                <span class="layout-topbar-item-text">Events</span>-->
<!--                <span class="layout-topbar-icon pi pi-calendar"></span>-->
<!--                <span class="layout-topbar-badge">5</span>-->
<!--            </button>-->
<!--            <button class="p-link">-->
<!--                <span class="layout-topbar-item-text">Settings</span>-->
<!--                <span class="layout-topbar-icon pi pi-cog"></span>-->
<!--            </button>-->
            <button class="p-link tooltip" @click="changeLanguage">
                <div class="tooltiptext">{{ $t('changeLanguage') }}</div>
                <span class="layout-topbar-item-text">Language</span>
                <span class="layout-topbar-icon pi pi-globe"></span>
            </button>
            <button class="p-link tooltip" @click="openProfile">
                <div class="tooltiptext">{{  $t('profile') }}</div>
                <span class="layout-topbar-item-text">User</span>
                <span class="layout-topbar-icon pi pi-user"></span>
            </button>
            <button class="p-link tooltip" @click="displayExitConfirmation = true">
                <div class="tooltiptext">{{  $t('logOut') }}</div>
                <span class="layout-topbar-item-text">Logout</span>
                <span class="layout-topbar-icon pi pi-power-off"></span>
            </button>
        </div>

        <YesNoDialog
                :displayModal.sync="displayExitConfirmation"
                @on-yes="logout"/>
    </div>
</template>

<script>
    import YesNoDialog from "./YesNoDialog";
    import {JwtToken} from "@/utils/jwt";

    export default {
        components: {
            YesNoDialog
        },
        data() {
            return {
                displayExitConfirmation: false
            }
        },
        methods: {
            onMenuToggle(event) {
                this.$emit('menu-toggle', event);
            },
            changeLanguage() {
                if (this.$root.$i18n.locale === 'dk') {
                    this.$root.$i18n.locale = 'en';
                } else {
                    this.$root.$i18n.locale = 'dk';
                }
            },
            openProfile() {
                const userId = JwtToken.fromLocalStorage().userId();
                this.$router.push(`/profile/${userId}`);
            },
            logout() {
                this.$router.push('/logout');
            }
        }
    }
</script>

<i18n lang="yaml" locale="en">
    changeLanguage: "Skift til Dansk"
    comingSoon: "Coming Soon"
    profile: "Profile"
</i18n>

<i18n lang="yaml" locale="dk">
    changeLanguage: "Change to English"
    comingSoon: "Kommer Snart"
    profile: "Profil"
</i18n>
